import React from "react";
import Header from "./Header";
import LiveTicker from "./LiveTicker";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0A0A0A] text-white">
      <Header />
      <LiveTicker />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
